// Central Benefits2 colour tokens. Single source of truth for the palette used
// by the MUI theme and by components. Values come from the Benefits2 Screen
// Fixes brief (accessibility-reviewed).

// Primary brand / text colours.
export const NAVY = "#0F1E4E" // body text, form labels, questions, secondary outline
export const LOGO_BLUE = "#2663E5" // primary buttons + interactive accents
export const LOGO_BLUE_DARK = "#1F52C0" // hover/pressed state for primary
export const TEAL = "#10A194" // DECORATIVE ONLY: large bold headers (24px+), pills — never body text
export const TEAL_PILL_BG = "rgba(16, 161, 148, 0.15)" // TEAL at 15% — pill/chip background
export const WHITE = "#FFFFFF"

// Neutral greys used across the flow.
export const GREY_BG = "#F0F0F0" // page background behind the white card
export const GREY_BORDER = "#707070"
export const GREY_TEXT = "#707070"

// Status.
export const ERROR_RED = "#ED385B"
export const SUCCESS_GREEN = "#66BB6A"

// Colours that FAIL WCAG AA and must never be used for text / white-on-fill.
// Kept here as a documented block so no one reintroduces them:
//   Logo Green #00A79D (white on it = 2.28:1)
//   Gold       #DFAF4A (white on it = 1.8:1)
//   Cyan       #25CFFD (white on it = 1.8:1)
//   Teal text  #10A194 (as body text = 3.12:1) — TEAL is decorative headers only
//   Lavender/periwinkle #6A75B9 (legacy button colour being removed)
export const FORBIDDEN_COLORS = {
  logoGreen: "#00A79D",
  gold: "#DFAF4A",
  cyan: "#25CFFD",
  lavender: "#6A75B9"
} as const
